import script from "./PurchaseHeader.vue?vue&type=script&setup=true&lang=js"
export * from "./PurchaseHeader.vue?vue&type=script&setup=true&lang=js"

import "./PurchaseHeader.vue?vue&type=style&index=0&id=ccfaa0c8&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-ccfaa0c8"]])

export default __exports__